<!--
 * @Author: chenyourong
 * @Date: 2025-05-08 18:06:50
 * @LastEditors: chenyourong
 * @LastEditTime: 2025-11-24 10:10:48
 * @Description: 
 * @FilePath: /vue-admin-template-master/src/views/businessManage/businessList/detail.vue
-->
<template>
  <div class="distribute-detail">
    <div v-if="$route.meta" class="header">{{ $route.meta.title }}</div>
    <Detail
      v-if="Object.keys(tableForm).length"
      ref="getDetail"
      :tableData="tableForm"
      :tableFormAttrs="tableFormAttrs"
      formLabelWidth="100px"
      :filterDataRules="filterDataRules"
      :merchantLogo="tableForm.merchantLogo"
      @submitForm="submitForm"
      @handleAvatarSuccess="handleAvatarSuccess"
    >
      <template v-slot:="button">
        <template v-if="isEdit">
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="submitFormDetail()">保存</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click="edit()">编辑</el-button>
        </template>
      </template>
    </Detail>
    <div class="shop-list" v-if="+type !== 4">
      <Search v-bind="filterAttrs" v-on="filterEvent"></Search>
      <div
        v-if="listQueryParams.total > 0"
        class="store-export-all"
      >
        <el-checkbox
          v-model="selectAllForExport"
          @change="handleSelectAllForExport"
        >
          勾选全部导出（共 {{ listQueryParams.total }} 家）
        </el-checkbox>
      </div>
      <Table
        ref="storeTable"
        :list-query-params.sync="listQueryParams"
        v-bind="tableAttrs"
        v-on="tableEvent"
      />
      <el-dialog
        :title="title"
        v-if="dialogFormVisible"
        :visible.sync="dialogFormVisible"
        width="572px"
        top="3vh"
      >
        <Detail
          ref="getTable"
          :title="title"
          :styleType="styleType"
          :tableData="dialogForm"
          :tableFormAttrs="dialogFormAttrs"
          formLabelWidth="91px"
          @resetSecret="resetSecret"
          :isEdit="title === '编辑门店'"
          @handleAreaChange="handleAreaChange"
        >
        </Detail>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm()">{{
            sureButtonsName
          }}</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="批量导入门店"
        :visible.sync="importDialogVisible"
        width="720px"
        top="5vh"
        :close-on-click-modal="!importing"
        @closed="resetImportDialog"
      >
        <el-alert
          type="info"
          :closable="false"
          show-icon
          title="Excel 格式要求（与 20260130.xlsx 一致）"
          class="import-alert"
        />
        <div class="import-format">
          <p>请使用固定表头，从第 2 行开始填写：</p>
          <el-table
            :data="importFormatPreview"
            border
            size="mini"
            style="width: 100%; margin: 8px 0 12px"
          >
            <el-table-column
              v-for="col in IMPORT_HEADERS"
              :key="col"
              :prop="col"
              :label="col"
              min-width="100"
            />
          </el-table>
          <ul class="import-tips">
            <li>列顺序不可调整，表头文字必须完全一致。</li>
            <li>省市区写成完整文字，例如：广东省珠海市斗门区。</li>
            <li>详细地址只填街道门牌，不要再重复写省市区。</li>
            <li>手机号必须唯一；系统已存在的手机会创建失败。</li>
            <li>初始密码可为空；所属商户自动使用当前商户，无需在表中填写。</li>
            <li>邮箱默认为空，状态默认启用。</li>
          </ul>
          <el-button type="text" icon="el-icon-download" @click="downloadImportTemplate">
            下载导入模板
          </el-button>
        </div>

        <el-upload
          ref="importUpload"
          action=""
          :auto-upload="false"
          :show-file-list="true"
          :limit="1"
          accept=".xlsx,.xls"
          :on-change="handleImportFileChange"
          :on-remove="handleImportFileRemove"
          :file-list="importFileList"
        >
          <el-button size="small" type="primary" :disabled="importing">
            选择 Excel 文件
          </el-button>
          <div slot="tip" class="el-upload__tip">仅支持 .xlsx / .xls</div>
        </el-upload>

        <div v-if="importRows.length" class="import-summary">
          已解析 <b>{{ importRows.length }}</b> 条门店数据，确认后将逐条创建。
        </div>

        <div v-if="importing || importResult.total" class="import-progress">
          <el-progress
            :percentage="importProgress"
            :status="importProgressStatus"
          />
          <div class="import-progress__text">
            进度：{{ importResult.done }} / {{ importResult.total }}
            （成功 {{ importResult.success }}，失败 {{ importResult.fail }}）
          </div>
          <el-table
            v-if="importResult.failList.length"
            :data="importResult.failList"
            border
            size="mini"
            max-height="220"
            style="width: 100%; margin-top: 10px"
          >
            <el-table-column prop="row" label="行号" width="70" />
            <el-table-column prop="storeName" label="门店名称" min-width="140" />
            <el-table-column prop="phone" label="手机号" width="120" />
            <el-table-column prop="msg" label="失败原因" min-width="180" />
          </el-table>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button :disabled="importing" @click="importDialogVisible = false">
            {{ importResult.done && importResult.done >= importResult.total ? "关闭" : "取消" }}
          </el-button>
          <el-button
            type="primary"
            :loading="importing"
            :disabled="!importRows.length || importing"
            @click="startImportStores"
          >
            开始导入
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Table from "@/components/Table/index.vue";
import Detail from "@/components/Detail/index.vue";
import Search from "@/components/Search/index.vue";
import md5 from "js-md5";
import Cookies from "js-cookie";
import { regionData } from "element-china-area-data";
import XLSX from "xlsx";
import { getPathName } from "@/utils/index.js";
import { extractProvinceCityDistrict } from "@/utils/index.js";

import {
  createStores,
  merchantList,
  merchantDetail,
  changeMerchant,
  storesList,
  changeStores,
  deleteStores,
  resetStoresSecret,
} from "@/api/business";

const DefaultTableQuery = {
  pageNum: 1,
  pageSize: 10,
};
const EXPORT_PAGE_SIZE = 1000;
const EXPORT_REQUEST_TIMEOUT = 120000;
const IMPORT_HEADERS = [
  "门店名称",
  "省市区",
  "详细地址",
  "联系人",
  "手机号",
  "初始密码（可为空）",
];
const IMPORT_TEMPLATE_URL = "/templates/store-import-template.xlsx";
const IMPORT_CREATE_TIMEOUT = 30000;

export default {
  name: "businessList",
  components: {
    Table,
    Detail,
    Search,
  },
  data() {
    return {
      type: +Cookies.get("type"),
      isEdit: false,
      tableForm: {},
      filterDataRules: ["discountRate"],
      tableFormAttrs: [
        {
          title: "商户名称:",
          placeholder: "请输入商户名称",
          type: "input",
          value: "merchantName",
          disabled: true,
        },
        {
          title: "Logo:",
          type: "upload",
          value: "merchantLogo",
          disabled: true,
        },
        {
          title: "商户描述:",
          placeholder: "请输入商户描述",
          type: "textarea",
          value: "merchantDesc",
          disabled: true,
        },
        {
          title: "商户ID:",
          placeholder: "系统自动生成",
          type: "input",
          value: "merchantId",
          disabled: true,
        },
        {
          title: "商户折扣率:",
          placeholder: "请输入折扣率",
          type: "input",
          inputType: "number",
          slot: "%",
          value: "discountRate",
          disabled: true,
          required: true,
        },
        {
          title: "联系人:",
          placeholder: "请输入联系人",
          type: "input",
          value: "contact",
          disabled: true,
        },
        {
          title: "手机号:",
          placeholder: "请输入手机号",
          type: "input",
          value: "phone",
          inputType: "number",
          disabled: true,
        },
        {
          title: "邮箱:",
          placeholder: "请输入邮箱",
          type: "input",
          value: "email",
          disabled: true,
        },
        {
          title: "状态:",
          placeholder: "",
          type: "radio",
          value: "status",
          disabled: true,
        },
        {
          title: "密码:",
          placeholder: "••••••••",
          type: "input",
          // inputType: "text",
          value: "passwd",
          isClosePwd: false,
          disabled: true,
        },
      ],
      title: "添加门店",
      sureButtonsName: "添加",
      styleType: "dialog",
      regionData,
      // 参数
      listQueryParams: { ...DefaultTableQuery },
      tableData: [],
      tableConfig: [
        {
          label: "门店名称",
          minWidth: "160",
          maxWidth: "520",
          autoWidth: true,
          value: "storeName",
        },
        {
          label: "门店地址",
          minWidth: "120",
          maxWidth: "400",
          autoWidth: true,
          value: "trimStoreAddr",
        },
        {
          label: "门店ID",
          minWidth: "80",
          maxWidth: "160",
          autoWidth: true,
          value: "storeId",
        },
        {
          label: "App ID",
          minWidth: "90",
          maxWidth: "220",
          autoWidth: true,
          value: "AppId",
        },
        {
          label: "App Secret",
          minWidth: "110",
          maxWidth: "280",
          autoWidth: true,
          value: "AppSecret",
        },
        {
          label: "IP白名单",
          minWidth: "100",
          maxWidth: "280",
          autoWidth: true,
          value: "ipWhiteList",
        },
        {
          label: "所属商户",
          minWidth: "90",
          maxWidth: "240",
          autoWidth: true,
          value: "merchantName",
        },
        {
          label: "联系人",
          minWidth: "70",
          maxWidth: "140",
          autoWidth: true,
          value: "contact",
        },
        {
          label: "手机号",
          minWidth: "90",
          maxWidth: "140",
          autoWidth: true,
          value: "phone",
        },
        {
          label: "状态",
          minWidth: "70",
          maxWidth: "90",
          autoWidth: true,
          format: "status",
          value: "status",
        },
      ],
      dialogFormAttrs: [
        {
          title: "门店名称:",
          placeholder: "请输入门店名称",
          type: "input",
          value: "storeName",
          required: true,
        },
        {
          title: "省市区/县:",
          placeholder: "请选择省市区/县",
          type: "multipleSelect",
          value: "area",
          required: true,
          options: [],
        },
        // {
        //   title: "市:",
        //   placeholder: "请选择市",
        //   type: "select",
        //   value: "city",
        //   required: true,
        // },
        // {
        //   title: "区/县:",
        //   placeholder: "请选择区/县",
        //   type: "select",
        //   value: "area",
        //   required: true,
        // },
        {
          title: "详细地址:",
          placeholder: "请输入详细地址",
          type: "textarea",
          value: "storeAddr",
          required: true,
        },
        {
          title: "门店ID:",
          placeholder: "系统自动生成",
          type: "input",
          inputType: "number",
          value: "storeId",
          disabled: true,
        },
        {
          title: "App ID:",
          placeholder: "系统自动生成",
          type: "input",
          value: "AppId",
          disabled: true,
        },
        {
          title: "App Secret:",
          placeholder: "系统自动生成",
          type: "input",
          value: "AppSecret",
          icon: "el-icon-refresh-right",
          disabled: true,
        },
        {
          title: "所属商户:",
          placeholder: "请输入所属商户",
          type: "select",
          value: "merchantId",
          required: true,
          options: [],
        },
        {
          title: "联系人:",
          placeholder: "请输入联系人",
          type: "input",
          value: "contact",
          required: true,
        },
        {
          title: "手机号:",
          placeholder: "请输入手机号或座机号",
          type: "input",
          value: "phone",
          required: true,
          skipPhoneFormat: true,
        },
        {
          title: "邮箱:",
          placeholder: "请输入邮箱",
          type: "input",
          value: "email",
          required: true,
        },
        {
          title: "状态:",
          placeholder: "",
          type: "radio",
          value: "status",
        },
        {
          title: "初始密码:",
          placeholder: "请输入密码",
          type: "input",
          inputType: "text",
          value: "passwd",
          isClosePwd: true,
        },
      ],
      // 表格加载loading
      loadingStatus: false,
      buttonsName: [
        {
          label: "编辑",
        },
        {
          label: "删除",
        },
      ],
      optionWidth: 148,
      dialogFormVisible: false,
      dialogForm: {},
      // url参数
      params: {
        pageSize: 10,
        pageNum: 0,
        searchKey: "",
        searchVal: "",
      },
      filterButtonText: [
        {
          label: "添加门店",
          type: "primary",
        },
        {
          label: "批量导入门店",
          type: "primary",
        },
        {
          label: "删除门店",
          type: "info",
        },
        {
          label: "导出Excel",
          type: "primary",
        },
      ],
      filterOptions: [],
      selectedAreaText: "",
      dialogStoreId: "",
      multipleSelection: [],
      selectedStoreMap: {},
      selectAllForExport: false,
      isRestoringSelection: false,
      importDialogVisible: false,
      importFileList: [],
      importRows: [],
      importing: false,
      importResult: {
        total: 0,
        done: 0,
        success: 0,
        fail: 0,
        failList: [],
      },
      IMPORT_HEADERS,
    };
  },
  computed: {
    importFormatPreview() {
      return [
        {
          门店名称: "珠海斗门南门汇店",
          省市区: "广东省珠海市斗门区",
          详细地址: "斗门大道1111号100C",
          联系人: "陈友勤",
          手机号: "13149312020",
          "初始密码（可为空）": "GL123456",
        },
      ];
    },
    importProgress() {
      if (!this.importResult.total) return 0;
      return Math.min(
        100,
        Math.round((this.importResult.done / this.importResult.total) * 100)
      );
    },
    importProgressStatus() {
      if (!this.importResult.total || this.importing) return undefined;
      if (this.importResult.fail === 0) return "success";
      if (this.importResult.success === 0) return "exception";
      return "warning";
    },
    // 表格属性
    tableAttrs() {
      return {
        // 表头配置
        config: this.tableConfig,
        // 表格数据
        tableData: this.tableData,
        // loading
        loadingStatus: this.loadingStatus,
        // 按钮名称
        buttonsName: this.buttonsName,
        // 操作栏宽度
        optionColumnWidth: this.optionWidth,
        // 是否需要选择
        isSelection: true,
        isShowNumber: true,
        rowKey: "storeId",
        reserveSelection: true,
      };
    },
    // 表格事件
    tableEvent() {
      return {
        // 按钮操作
        subOpitonButton: this.handleTableOption,
        // 分页
        subClickPagination: this.handleRefreshList,
        // 表格数据选择
        subSelected: this.handleSelectionChange,
      };
    },
    filterAttrs() {
      return {
        // 按钮名称：批量导入仅平台管理员可见
        filterButtonText: this.filterButtonText.filter((item) => {
          if (item.label === "批量导入门店") {
            return this.isPlatformAdmin;
          }
          return true;
        }),
        filterOptions: this.filterOptions,
      };
    },
    isPlatformAdmin() {
      return this.type === 1 && String(Cookies.get("storeId")) === "1";
    },
    filterEvent() {
      return {
        // 选择数据回调
        handleFilter: this.handleFilter,
        handleFilterButton: this.handleFilterButton,
        clickSearch: this.clickSearch,
      };
    },
  },
  watch: {
    multipleSelection: {
      handler: function (val) {
        this.filterButtonText.forEach((item) => {
          if (item.label === "删除门店") {
            item.type = val.length ? "primary" : "info";
          }
        });
      },
      immediate: true,
    },
    isEdit(val) {
      this.tableFormAttrs.forEach((item) => {
        item.disabled = !val;
        if (item.value === "merchantId") {
          item.disabled = true;
        }
        if (item.value === "passwd") {
          item.placeholder = "••••••••";
          item.title = "密码";
          item.isClosePwd = false;
          if (!val) return false;
          item.placeholder = "请输入新密码";
          item.title = "重置密码";
          item.isClosePwd = true;
        }
      });
    },
  },
  created() {
    this.dialogFormAttrs.forEach((item) => {
      if (item.type === "multipleSelect") {
        item.options = this.regionData;
      }
      if (item.value === "merchantId") {
        // val.options
        merchantList({
          pageNum: 0,
          pageSize: 1000,
        }).then((res) => {
          res.data.list.forEach((val) => {
            item.options.push({
              label: val.merchantName,
              value: val.merchantId,
            });
          });
        });
      }
    });
    this.getMerchantDetail();
    this.getList();
  },
  methods: {
    async getMerchantDetail() {
      const { data } = await merchantDetail({
        merchantId: this.$route.params.id,
      });
      if ([4].includes(this.type)) {
        this.tableFormAttrs = this.tableFormAttrs.filter(
          (item) => !["discountRate"].includes(item.value)
        );
      }

      this.tableForm = data;
      this.tableForm.merchantLogo = this.tableForm.merchantLogo;
      this.tableForm.status = this.tableForm.status.toString();
      this.tableForm.discountRate = this.tableForm.discountRate * 100;
    },
    async submitFormDetail() {
      this.$refs.getDetail.getTableRef().validate((valid) => {
        console.log(valid);
        if (valid) {
          const params = {
            ...this.tableForm,
            discountRate: this.tableForm.discountRate / 100,
            status: +this.tableForm.status,
            passwd: this.tableForm.passwd
              ? md5(md5(this.tableForm.passwd))
              : md5(md5("")),
          };
          // params.discountRate = this.tableForm.discountRate / 100;
          // params.status = +this.tableForm.status
          // params.passwd  = this.tableForm.passwd ? md5(md5(this.tableForm.passwd)) : md5(md5(''));
          changeMerchant(params).then((res) => {
            if (res.code === 0) {
              this.$message.success("修改成功");
              this.isEdit = false;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleAvatarSuccess(img) {
      this.tableForm.merchantLogo = img;
    },
    cancel() {
      this.isEdit = false;
      this.tableFormAttrs.forEach((item) => {
        item.disabled = true;
      });
    },
    edit() {
      if (this.type === 4) {
        this.$message.error("没有编辑权限");
        return false;
      }
      this.isEdit = true;
    },
    // 获取列表
    async getList(storeId) {
      try {
        // 表格加载loading
        this.loadingStatus = true;
        // 分页数据作为参数给服务端
        this.params.pageSize = this.listQueryParams.pageSize;
        this.params.pageNum = this.listQueryParams.pageNum - 1;
        this.params.searchKey = "merchantId";
        this.params.searchVal = this.$route.params.id;
        // this.params.searchKey = 'merchantId';
        // this.params.searchVal = this.$route.params.id;
        // 发送请求,请求到的数据格式见下文，
        const { data } = await storesList(this.params);
        if (data.list) {
          data.list.forEach((item) => {
            if (item.storeId === storeId) {
              this.dialogForm.AppSecret = item.AppSecret;
            }
            item.status = item.status.toString();
            item.statusDes = +item.status === 0 ? '启用' : '暂停';
            console.log("🚀 ~ data.list.forEach ~ item.status:", item.status)
            item.trimStoreAddr = item.storeAddr.split(' ').join('');
          });
        }
        this.listQueryParams.total = data.total;
        // 数据给表格
        this.tableData = data.list || [];
        this.loadingStatus = false;
        this.$nextTick(() => {
          this.restoreTableSelection();
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 点击上传
    handleAvatarSuccess(img) {
      this.tableForm.merchantLogo = img;
    },
    resetSecret() {
      this.$confirm("确认重置App Secret?", "", {
        type: "warning",
        confirmButtonText: "是",
        cancelButtonText: "否",
      })
        .then((res) => {
          resetStoresSecret({
            storeId: this.dialogForm.storeId,
          }).then((res) => {
            this.getList(this.dialogForm.storeId);
            this.$message.success("重置App Secret成功");
          });
        })
        .catch(() => {
          this.$message.info(`已取消重置App Secret`);
        });
    },
    // 点击添加按钮
    submitForm() {
      this.$refs.getTable.getTableRef().validate((valid) => {
        if (valid) {
          const params = {
            storeName: this.dialogForm.storeName,
            // storeAddr: this.dialogForm.storeAddr,
            merchantId: this.dialogForm.merchantId,
            contact: this.dialogForm.contact,
            phone: this.dialogForm.phone,
            email: this.dialogForm.email,
            ipWhiteList: this.dialogForm.ipWhiteList,
            passwd: this.dialogForm.passwd
              ? md5(md5(this.dialogForm.passwd))
              : md5(md5("")),
            status: Number(this.dialogForm.status),
          };
          params.storeAddr = this.buildStoreAddr();
          if (this.title === "添加门店") {
            createStores(params).then((res) => {
              this.getList();
              this.$message({
                message: "添加成功",
                type: "success",
              });
            });
            this.dialogFormVisible = false;
          }
          if (this.title === "编辑门店") {
            params.storeId = this.dialogStoreId;
            changeStores(params).then((res) => {
              this.getList();
              this.$message({
                message: "修改成功",
                type: "success",
              });
            });
            this.dialogFormVisible = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    buildStoreAddr() {
      const areaPart = (this.selectedAreaText || "").trim();
      const addrPart = (this.dialogForm.storeAddr || "").trim();
      return [areaPart, addrPart].filter(Boolean).join(" ");
    },
    parseStoreAddrForEdit(storeAddr) {
      const fullAddr = (storeAddr || "").trim();
      if (!fullAddr) {
        this.dialogForm.area = [];
        this.selectedAreaText = "";
        this.dialogForm.storeAddr = "";
        return;
      }
      const arr = [];
      let currentOptions = this.regionData;
      fullAddr.split(" ").forEach((code) => {
        const option = currentOptions.find((item) => item.label === code);
        if (option) {
          arr.push(option.value);
          currentOptions = option.children || [];
        }
      });
      this.dialogForm.area = arr;
      this.selectedAreaText = extractProvinceCityDistrict(fullAddr);
      this.dialogForm.storeAddr = fullAddr.split(" ").slice(-1)[0];
    },
    handleAreaChange(value) {
      let areaText = "";
      let currentOptions = this.regionData;
      value.forEach((code, index) => {
        const option = currentOptions.find((item) => item.value === code);
        if (option) {
          areaText += option.label + " ";
          currentOptions = option.children || [];
        }
      });
      this.selectedAreaText = areaText;
    },
    // 删除商户
    deleteShopDialog() {
      this.$confirm("确定删除吗?", "", {
        type: "warning",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async () => {
          this.$message.success(" 删除成功");
        })
        .catch(() => {
          this.$message.info(" 已取消删除");
        });
    },
    handleFilter(val) {
      this.params.searchKey = val.selectValue;
    },
    getStoreTableRef() {
      return this.$refs.storeTable && this.$refs.storeTable.$refs.multipleTable;
    },
    restoreTableSelection() {
      this.isRestoringSelection = true;
      const table = this.getStoreTableRef();
      if (!table) {
        this.isRestoringSelection = false;
        return;
      }
      table.clearSelection();
      if (this.selectAllForExport) {
        this.tableData.forEach((row) => {
          table.toggleRowSelection(row, true);
        });
      } else {
        this.tableData.forEach((row) => {
          if (this.selectedStoreMap[String(row.storeId)]) {
            table.toggleRowSelection(row, true);
          }
        });
      }
      this.$nextTick(() => {
        this.isRestoringSelection = false;
      });
    },
    handleSelectAllForExport(checked) {
      if (checked) {
        this.selectAllForExport = true;
        this.selectedStoreMap = {};
        this.multipleSelection = [];
        this.$nextTick(() => {
          this.restoreTableSelection();
        });
        return;
      }
      this.selectAllForExport = false;
      const table = this.getStoreTableRef();
      if (table) {
        table.clearSelection();
      }
    },
    syncStoreSelection(selectedOnPage) {
      if (this.selectAllForExport) {
        this.selectAllForExport = false;
      }
      const currentPageIds = this.tableData.map((row) => String(row.storeId));
      const selectedIds = new Set(
        (selectedOnPage || []).map((row) => String(row.storeId))
      );
      currentPageIds.forEach((id) => {
        if (!selectedIds.has(id)) {
          delete this.selectedStoreMap[id];
        }
      });
      (selectedOnPage || []).forEach((row) => {
        this.selectedStoreMap[String(row.storeId)] = row;
      });
      this.multipleSelection = Object.values(this.selectedStoreMap);
    },
    // 多选框
    handleSelectionChange(val) {
      if (this.isRestoringSelection) {
        return;
      }
      this.syncStoreSelection(val);
    },
    // 点击编辑
    handleTableOption(index, row, option) {
      this.operationalData = { ...row };
      if (option.label === "查看") {
        console.log(index, row, option);
      } else if (option.label === "编辑") {
        var row = JSON.parse(JSON.stringify(row));
        this.dialogFormVisible = true;
        this.title = "编辑门店";
        this.sureButtonsName = "确定";
        this.dialogForm = row;
        this.dialogForm.status = row.status.toString();
        this.parseStoreAddrForEdit(this.dialogForm.storeAddr);
        this.dialogStoreId = this.dialogForm.storeId;

        this.dialogFormAttrs.forEach((val) => {
          if (val.isClosePwd) {
            val.title = "重置密码:";
          }
          if (val.value === "AppSecret") {
            val.icon = "el-icon-refresh-right";
          }
        });
        console.log(index, row, option);
      } else if (option.label === "删除") {
        this.$confirm("确定删除门店吗?", "", {
          type: "warning",
          confirmButtonText: "是",
          cancelButtonText: "否",
        })
          .then(async () => {
            deleteStores({
              storeIds: [row.storeId],
            }).then((res) => {
              this.getList();
              this.$message.success(" 删除成功");
            });
          })
          .catch(() => {
            this.$message.info(" 已取消删除");
          });

        console.log(index, row, option);
      }
    },
    // 分页操作
    handleRefreshList() {
      this.getList();
    },
    clickSearch(val) {
      this.params.searchKey = val.selectValue;
      this.params.searchVal = val.inputValue;
      this.listQueryParams.pageNum = 1; // 重置页码
      this.getList();
    },
    // 点击右上角添加门店或者删除门店按钮
    async handleFilterButton(val) {
      if (val === "添加门店") {
        this.dialogFormVisible = true;
        this.title = "添加门店";
        this.sureButtonsName = "添加";
        this.dialogForm = {};
        this.dialogFormAttrs.forEach((val) => {
          if (val.isClosePwd) {
            val.title = "密码:";
          }
          if (val.value === "AppSecret") {
            val.icon = "";
          }
        });
      }
      if (val === "批量导入门店") {
        if (!this.isPlatformAdmin) {
          this.$message.error("只有平台管理员才能批量导入门店");
          return;
        }
        this.importDialogVisible = true;
      }
      if (val === "删除门店") {
        if (!this.multipleSelection.length) return false;
        this.$confirm("确定删除吗?", "", {
          type: "warning",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(async () => {
            const storeIds = this.multipleSelection.map((val) => val.storeId);
            await deleteStores({
              storeIds,
            });
            this.getList();
            this.$message.success(" 删除成功");
          })
          .catch(() => {
            this.$message.info(" 已取消删除");
          });
      }

      if (val === "导出Excel") {
        this.exportExcel();
      }
    },
    resetImportDialog() {
      if (this.importing) return;
      this.importFileList = [];
      this.importRows = [];
      this.importResult = {
        total: 0,
        done: 0,
        success: 0,
        fail: 0,
        failList: [],
      };
      if (this.$refs.importUpload) {
        this.$refs.importUpload.clearFiles();
      }
    },
    downloadImportTemplate() {
      const link = document.createElement("a");
      link.href = IMPORT_TEMPLATE_URL;
      link.download = "门店批量导入模板.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    handleImportFileRemove() {
      this.importFileList = [];
      this.importRows = [];
    },
    handleImportFileChange(file, fileList) {
      this.importFileList = fileList.slice(-1);
      const raw = file && file.raw;
      if (!raw) return;
      const name = (raw.name || "").toLowerCase();
      if (!name.endsWith(".xlsx") && !name.endsWith(".xls")) {
        this.$message.error("请上传 Excel 文件（.xlsx / .xls）");
        this.handleImportFileRemove();
        return;
      }
      this.parseImportExcel(raw);
    },
    cellToText(value) {
      if (value === null || value === undefined) return "";
      if (typeof value === "number") {
        // 避免手机号被科学计数法/丢精度
        return String(Math.trunc(value));
      }
      return String(value).trim();
    },
    async parseImportExcel(file) {
      try {
        const buffer = await file.arrayBuffer();
        const workbook = XLSX.read(buffer, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(sheet, {
          header: 1,
          defval: "",
          raw: true,
        });
        if (!rows.length) {
          this.$message.error("Excel 内容为空");
          this.importRows = [];
          return;
        }
        const header = (rows[0] || []).map((item) => this.cellToText(item));
        const missing = IMPORT_HEADERS.filter((h, idx) => header[idx] !== h);
        if (missing.length || header.length < IMPORT_HEADERS.length) {
          this.$message.error(
            `表头不正确，请使用模板。正确表头：${IMPORT_HEADERS.join(" | ")}`
          );
          this.importRows = [];
          return;
        }

        const parsed = [];
        for (let i = 1; i < rows.length; i++) {
          const row = rows[i] || [];
          const storeName = this.cellToText(row[0]);
          const areaText = this.cellToText(row[1]);
          const detailAddr = this.cellToText(row[2]);
          const contact = this.cellToText(row[3]);
          const phone = this.cellToText(row[4]);
          const passwd = this.cellToText(row[5]);
          if (
            !storeName &&
            !areaText &&
            !detailAddr &&
            !contact &&
            !phone &&
            !passwd
          ) {
            continue;
          }
          parsed.push({
            rowNum: i + 1,
            storeName,
            areaText,
            detailAddr,
            contact,
            phone,
            passwd,
          });
        }
        if (!parsed.length) {
          this.$message.warning("未解析到有效门店数据");
          this.importRows = [];
          return;
        }
        this.importRows = parsed;
        this.importResult = {
          total: 0,
          done: 0,
          success: 0,
          fail: 0,
          failList: [],
        };
        this.$message.success(`已解析 ${parsed.length} 条门店数据`);
      } catch (error) {
        console.log(error);
        this.importRows = [];
        this.$message.error("解析 Excel 失败，请检查文件格式");
      }
    },
    validateImportRow(row) {
      if (!row.storeName) return "门店名称不能为空";
      if (!row.areaText) return "省市区不能为空";
      if (!row.detailAddr) return "详细地址不能为空";
      if (!row.contact) return "联系人不能为空";
      if (!row.phone) return "手机号不能为空";
      if (!/^\d{6,20}$/.test(row.phone)) return "手机号格式不正确";
      return "";
    },
    async startImportStores() {
      if (!this.isPlatformAdmin) {
        this.$message.error("只有平台管理员才能批量导入门店");
        return;
      }
      if (!this.importRows.length || this.importing) return;
      const merchantId = String(this.$route.params.id || "");
      if (!merchantId) {
        this.$message.error("缺少商户ID");
        return;
      }
      try {
        await this.$confirm(
          `确认为当前商户导入 ${this.importRows.length} 家门店吗？`,
          "批量导入确认",
          {
            type: "warning",
            confirmButtonText: "开始导入",
            cancelButtonText: "取消",
          }
        );
      } catch (e) {
        return;
      }

      this.importing = true;
      this.importResult = {
        total: this.importRows.length,
        done: 0,
        success: 0,
        fail: 0,
        failList: [],
      };

      for (const row of this.importRows) {
        const errMsg = this.validateImportRow(row);
        if (errMsg) {
          this.importResult.fail += 1;
          this.importResult.failList.push({
            row: row.rowNum,
            storeName: row.storeName,
            phone: row.phone,
            msg: errMsg,
          });
          this.importResult.done += 1;
          continue;
        }

        const params = {
          storeName: row.storeName,
          storeAddr: `${row.areaText} ${row.detailAddr}`.trim(),
          merchantId,
          contact: row.contact,
          phone: row.phone,
          email: "",
          ipWhiteList: "",
          passwd: md5(md5(row.passwd || "")),
          status: 0,
        };

        try {
          await createStores(params, {
            silent: true,
            timeout: IMPORT_CREATE_TIMEOUT,
          });
          this.importResult.success += 1;
        } catch (error) {
          this.importResult.fail += 1;
          this.importResult.failList.push({
            row: row.rowNum,
            storeName: row.storeName,
            phone: row.phone,
            msg: (error && error.message) || "创建失败",
          });
        }
        this.importResult.done += 1;
      }

      this.importing = false;
      this.getList();
      if (this.importResult.fail === 0) {
        this.$message.success(
          `导入完成：成功 ${this.importResult.success} 家门店`
        );
      } else {
        this.$message.warning(
          `导入结束：成功 ${this.importResult.success}，失败 ${this.importResult.fail}（见下方明细）`
        );
      }
    },
    setExportLoadingText(loading, text) {
      if (loading && loading.$el) {
        const textEl = loading.$el.querySelector(".el-loading-text");
        if (textEl) {
          textEl.textContent = text;
        }
      }
    },
    async fetchAllStoresForExport(loading) {
      const merchantId = this.$route.params.id;
      const allList = [];
      let pageNum = 0;
      let total = 0;

      while (true) {
        const { data } = await storesList(
          {
            searchKey: "merchantId",
            searchVal: merchantId,
            pageSize: EXPORT_PAGE_SIZE,
            pageNum,
          },
          { timeout: EXPORT_REQUEST_TIMEOUT }
        );
        if (pageNum === 0) {
          total = data.total || 0;
          if (total === 0) {
            return allList;
          }
          this.setExportLoadingText(
            loading,
            `正在导出，共 ${total} 条门店...`
          );
        }
        const list = data.list || [];
        if (!list.length) {
          break;
        }
        list.forEach((item) => this.normalizeStoreExportItem(item));
        allList.push(...list);
        this.setExportLoadingText(
          loading,
          `正在导出 ${allList.length}/${total} 条门店...`
        );
        pageNum += 1;
        if (list.length < EXPORT_PAGE_SIZE) {
          break;
        }
        if (allList.length >= total) {
          break;
        }
      }

      return allList;
    },
    normalizeStoreExportItem(item) {
      item.statusDes = +item.status === 0 ? "启用" : "暂停";
      item.trimStoreAddr = (item.storeAddr || "").split(" ").join("");
      item.AppId = item.AppId || item.appId || "";
      item.AppSecret = item.AppSecret || item.appSecret || "";
    },
    async exportExcel() {
      const headers = [
        "门店名称",
        "门店地址",
        "门店ID",
        "App ID",
        "App Secret",
        "IP白名单",
        "所属商户",
        "联系人",
        "手机号",
        "状态",
      ];
      const keys = [
        "storeName",
        "trimStoreAddr",
        "storeId",
        "AppId",
        "AppSecret",
        "ipWhiteList",
        "merchantName",
        "contact",
        "phone",
        "statusDes",
      ];
      const loading = this.$loading({
        lock: true,
        text: "正在导出，请稍候...",
      });
      try {
        let arr = [];
        if (this.selectAllForExport) {
          this.setExportLoadingText(loading, "正在加载门店数据...");
          arr = await this.fetchAllStoresForExport(loading);
        } else if (this.multipleSelection.length) {
          arr = this.multipleSelection.map((item) => {
            const row = { ...item };
            this.normalizeStoreExportItem(row);
            return row;
          });
        } else {
          this.setExportLoadingText(loading, "正在加载门店数据...");
          arr = await this.fetchAllStoresForExport(loading);
        }
        if (!arr.length) {
          this.$message.warning("暂无数据可导出");
          return;
        }
        const exportData = arr.map((item) => keys.map((key) => item[key]));
        exportData.unshift(headers);
        const ws = XLSX.utils.aoa_to_sheet(exportData);
        ws["!cols"] = [
          { wch: 18 },
          { wch: 45 },
          { wch: 12 },
          { wch: 15 },
          { wch: 35 },
          { wch: 25 },
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 12 },
        ];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, `商户门店${getPathName()}.xlsx`);
      } catch (error) {
        console.log(error);
        this.$message.error("导出失败，请稍后重试");
      } finally {
        loading.close();
      }
    },
  },
};
</script>
<style lang="scss">
.distribute-detail {
  position: relative;
  .content {
    padding-bottom: 26px;
  }
  .el-dialog__wrapper {
    display: inherit;
  }
  .header {
    color: rgba(0, 0, 0, 0.85);
    padding: 0 0 24px 24px;
    border-bottom: 1px solid rgba(240, 240, 240, 1);
    background: #fff;
    padding-top: 20px;
  }
  .shop-list {
    .filter-container {
      flex-wrap: wrap;
      align-items: center;
      row-gap: 8px;
      height: auto !important;
      min-height: 64px;
      padding: 12px 24px !important;
      overflow: visible;

      .filter-container__left {
        width: auto;
        flex: 0 1 auto;
        min-width: 80px;
      }

      .filter-container__right {
        flex: 1 1 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        gap: 8px;
        min-width: 0;

        .el-button {
          width: auto !important;
          min-width: 88px;
          height: 32px;
          line-height: 32px;
          padding: 0 12px !important;
          font-size: 14px;
          white-space: nowrap;
        }
        .el-button--primary {
          background: #1890ff;
        }
        .el-button--info {
          background: #f5f5f5;
          color: rgba(0, 0, 0, 0.25);
        }
      }

      .el-input {
        width: 265px;
        input {
          height: 32px;
        }
        .el-input__inner {
          height: 32px;
          line-height: 32px;
        }
      }
      .el-select {
        margin-right: 4px;
        .el-input {
          width: 106px;
        }
      }
      .el-input-group__append {
        background: #fff;
      }
    }
    .deleteShopDialog {
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        display: flex;
        align-items: center;
        border: none;
      }
      .el-icon-warning-outline {
        font-size: 22px;
        color: #faad14;
        margin-right: 16px;
      }
      .el-dialog__footer {
        padding: 0px 20px 20px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
.shop-list {
  .filter-container {
    @include flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 12px 24px;
    width: 100%;
    height: auto;
    min-height: 64px;
    background: #fff;
    margin: 20px 0 0;
    border-bottom: 1px solid #f0f0f0;
    overflow: visible;
  }
  .show-pwd {
    position: absolute;
    right: 60px;
    top: 0;
    font-size: 16px;
    color: #000;
    cursor: pointer;
    user-select: none;
  }
  .char-count {
    text-align: right;
    color: #666;
    font-size: 12px;
    margin-top: 4px;
  }

  .limit-reached {
    color: #f56c6c;
    font-weight: bold;
  }
  .store-export-all {
    padding: 12px 24px 0;
    background: #fff;
  }
}

.import-alert {
  margin-bottom: 12px;
}
.import-format {
  margin-bottom: 16px;
  p {
    margin: 0;
    color: #606266;
    font-size: 13px;
  }
}
.import-tips {
  margin: 0 0 8px;
  padding-left: 18px;
  color: #606266;
  font-size: 13px;
  line-height: 1.7;
}
.import-summary {
  margin-top: 12px;
  color: #303133;
  font-size: 13px;
}
.import-progress {
  margin-top: 16px;
  &__text {
    margin-top: 8px;
    color: #606266;
    font-size: 13px;
  }
}
</style>
